import React from "react";
import Chart from "react-apexcharts";

const SalesDayChart = ({ details }) => {
  const labels = details?.labels || [];
  const chartData = details?.chart || [];

  const revenueSeries = chartData.map((item) => item.revenue);

  const options = {
    chart: {
      height: 245,
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    colors: ["#FE9F43", "#FFE3CB"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        borderRadius: 8,
        borderRadiusWhenStacked: "all",
        horizontal: false,
        endingShape: "rounded",
      },
    },
    xaxis: {
      categories: labels,
      labels: {
        style: {
          colors: "#6B7280",
          fontSize: "13px",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => {
          return val.toFixed(0); // remove 'K' for real values
        },
        offsetX: -15,
        style: {
          colors: "#6B7280",
          fontSize: "13px",
        },
      },
    },
    grid: {
      borderColor: "#E5E7EB",
      strokeDashArray: 5,
      padding: {
        left: -16,
        top: 0,
        bottom: 0,
        right: 0,
      },
    },
    legend: {
      show: true,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      opacity: 1,
    },
  };

  const series = [
    {
      name: "Revenue",
      data: revenueSeries,
    }
  ];

  return (
    <div id="sales-daychart">
      <Chart options={options} series={series} type="bar" height={350} />
    </div>
  );
};

export default SalesDayChart;